import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    display: block;
    opacity: 0.8;
`;

export const AdvantageItem = styled.div`
    align-items: center;
`;

export const Icon = styled.img`
    width: 22px;
    height: 38px;
`;

export const Title = styled.p`
    ${FONTS.L};
    color: ${COLORS.white};
    margin-left: 16px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.M};
        margin-left: 9x;
    }
`;
